<template>
  <footer>
    <div class="container">
      <div class="footer-grid">
        <div class="footer-column">
          <h3> <router-link exact-active-class="active" to="/">{{ siteData.site.name }}</router-link></h3>
          <p>Your one-stop shop for all your needs with great deals and discounts.</p>
          <div class="social-icons">
            <a href="#"><i class="fab fa-facebook-f"></i></a>
            <a href="#"><i class="fab fa-twitter"></i></a>
            <a href="#"><i class="fab fa-instagram"></i></a>
            <a href="#"><i class="fab fa-youtube"></i></a>
          </div>
        </div>
        <div class="footer-column">
          <h4>Web Site</h4>
          <ul>
            <li> <router-link exact-active-class="active" to="/docs">Documantation</router-link></li>
            <li> <router-link exact-active-class="active" to="/privacy">Privacy policy</router-link></li>
            <li> <router-link exact-active-class="active" to="/products">Products</router-link></li>
            <li> <router-link exact-active-class="active" to="/site/version">Version Report</router-link></li>
            <li> <router-link exact-active-class="active" to="/site/safety">Electrical And Safety</router-link></li>
          </ul>
        </div>
        <div class="footer-column">
          <h4>Customer Service</h4>
          <ul>
            <li> <router-link exact-active-class="active" to="/contact">Contact Us</router-link></li>
            <li> <router-link exact-active-class="active" to="/contacts/q&a">FAQs</router-link></li>
            <li> <router-link exact-active-class="active" to="/">Shipping Policy</router-link></li>
            <li> <router-link exact-active-class="active" to="/products/returns">Returns & Refunds</router-link></li>
            <li> <router-link exact-active-class="active" to="/site/datasheets">MSDS Datasheets</router-link></li>
          </ul>
        </div>
        <div class="footer-column">
          <h4>My Account</h4>
          <ul>
            <li> <router-link exact-active-class="active" to="/user/login">Sign In</router-link></li>
            <li> <router-link exact-active-class="active" to="/products/cart">View Cart</router-link></li>
            <li> <router-link exact-active-class="active" to="/products/wishlist">My Wishlist</router-link></li>
            <li> <router-link exact-active-class="active" to="/products/orders">Order History</router-link></li>
            <li> <router-link exact-active-class="active" to="/products/track-order">Track Order</router-link></li>
          </ul>
        </div>
      </div>
      <div class="footer-bottom">
        <p>{{ siteData.site.copyright }}</p>
        <div class="payment-methods">
          <i class="fab fa-cc-visa"></i>
          <i class="fab fa-cc-mastercard"></i>
          <i class="fab fa-cc-amex"></i>
          <i class="fab fa-cc-paypal"></i>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import site from '@/../public/site.json';

export default {
  name: 'FooterSection',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
    siteData() {
      return site;
    }
  }
}
</script>

<style scoped>
footer {
  background-color: #212121;
  color: var(--white);
  padding: 60px 0 20px;
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  margin-bottom: 40px;
}

.footer-column h3 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
  color: var(--primary-light);
}

.footer-column h4 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  color: var(--white);
}

.footer-column p {
  margin-bottom: 20px;
  color: var(--gray);
}

.social-icons {
  display: flex;
  gap: 15px;
}

.social-icons a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  transition: var(--transition);
}

.social-icons a:hover {
  background-color: var(--primary-color);
}

.footer-column ul li {
  margin-bottom: 10px;
}

.footer-column ul li a {
  color: var(--gray);
  transition: var(--transition);
}

.footer-column ul li a:hover {
  color: var(--primary-light);
}
.footer-column ul li .active {
  color: var(--primary-light);
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-bottom p {
  color: var(--gray);
}

.payment-methods {
  display: flex;
  gap: 10px;
  font-size: 24px;
}

@media (max-width: 992px) {
  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .footer-grid {
    grid-template-columns: 1fr;
  }

  .footer-bottom {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
}
</style>